import { render, staticRenderFns } from "./modalTipoRegistro.vue?vue&type=template&id=7adcc542&scoped=true&"
import script from "./modalTipoRegistro.vue?vue&type=script&lang=js&"
export * from "./modalTipoRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adcc542",
  null
  
)

export default component.exports